import { FetchPolicy, graphql, useLazyLoadQuery } from "react-relay"
import { useDeMedicationDetailByIdQuery as useDeMedicationDetailByIdQueryType } from "@/modules/patients/detail/medication/de/services/__generated__/useDeMedicationDetailByIdQuery.graphql"

const query = graphql`
  query useDeMedicationDetailByIdQuery($id: ID!, $skip: Boolean!) {
    de_medicationDetailById(id: $id) @skip(if: $skip) {
      ... on de_SuccessMedicationDetailResult {
        result {
          id
          canDelete
        }
      }
    }
  }
`

type useDeMedicationDetailByIdQueryProps = {
  id: string
  fetchPolicy?: FetchPolicy
}

const useDeMedicationDetailByIdQuery = ({ id, fetchPolicy }: useDeMedicationDetailByIdQueryProps) => {
  const { de_medicationDetailById } = useLazyLoadQuery<useDeMedicationDetailByIdQueryType>(
    query,
    {
      id,
      skip: !id || id.length === 0,
    },
    {
      fetchPolicy,
    },
  )

  return de_medicationDetailById
}

export { useDeMedicationDetailByIdQuery }
